module.exports = __webpack_public_path__ + "img/nuxtjs-title.d3777795.svg";